// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3wZOe","title":"ClientInsurance_title__696fU","itemText":"ClientInsurance_itemText__vJ6py"};